import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {GoriSignatureManual} from '../../modules/gori-signature'

export default function GoriSignatureManualWrapper() {
  return (
    <PublicWrapper>
      <GoriSignatureManual />
    </PublicWrapper>
  )
}
